export default "__VITE_ASSET__111dc84a__"